module.exports = __webpack_public_path__ + "static/media/p7.92e6253c.jpg";